import React from 'react';
import { useLocation } from 'react-router-dom';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import PostsCalendarSearch from '../components/PostsCalendarSearch';
import Footer from '../components/Footer';

const ProfileLayout = ({ children, profileId }) => {
  const location = useLocation();
  const isDashboard = location.pathname.includes('/dashboard');

  return (
    <div className="min-h-screen bg-secondary flex flex-col">
      <TopBar />
      <div className="container mx-auto px-4 py-8 flex-grow">
        {/* Mobile: Sidebar on top, content below */}
        {/* Desktop: Sidebar left, content right */}
        <div className="flex flex-col md:flex-row gap-6 md:items-start">
          <div className="md:self-start space-y-6">
            <Sidebar memberId={profileId} />
            {isDashboard && profileId && (
              <PostsCalendarSearch profileId={profileId} />
            )}
          </div>
          <main className="flex-1">
            {React.cloneElement(children, { viewingProfileId: profileId })}
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ProfileLayout;
